import { createIsomorphicFn } from "@tanstack/react-start"

export const currentRequestHostname = createIsomorphicFn()
  .client(() => window.location.hostname)
  .server(async () => {
    const { getRequestHeader } = await import("@tanstack/react-start/server")
    return getRequestHeader("x-forwarded-host") ?? getRequestHeader("host") ?? ""
  })
